import { useSelector } from "react-redux";
import { HeaderContent, HeaderLayout, HelpIconHeader, ConnectIconHeader } from "../../atoms/Header";
import Logo from "../../atoms/Logo";
import { Div } from "../../atoms/Div";
import MenuIcon from "../../molecule/MenuIcon/MenuIcon";
import { AutoCompleteWrapper, ConnectText, NewsfeedIconHeader, HomeIconHeader, CloseIcon, MapIconHeader } from "../../atoms/Header";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { StationModalHeader } from "../../atoms/Header";
import { BackButton } from "../../atoms/Header";
import AutoCompleteSearch from "../../molecule/AutoCompleteSearch/AutoCompleteSearch";
import { isMobile } from "../../../utilities/deviceUtilities";
import { decrypt, encrypt } from "../../../utilities/tokenizer";
import { Text } from "../../atoms/TextField";
import GiveIcon from "../../molecule/GiveIcon/Index";
import * as Utilites from "@mywvglobal-shared/mywv-shared/common/utilities";
import { useEffect, useState } from "react";
import useAlert from "../../../hooks/useAlert";
import { gaEvent } from "../../../utilities/analytics";
import ChildSearchView from "../../pages/Home/childSearchView";

export default function Header(props) {

  const { children } = props;
  const { persistItemsReducer } = useSelector((state) => state);
  const { t } = useTranslation();

  return (
    <HeaderLayout ref={element => {
      if (element) element.style.setProperty("display", "flex", "important");
    }}>
      {props?.world && isMobile(740) ? null : <HeaderContent logo left>
        <Logo soCode={persistItemsReducer?.selectedSOData?.soCode} onClicklogo={() => props?.handleCloseClick()} />
      </HeaderContent>}

      {isMobile(740) ? null : <HeaderContent disclaimer>
        <Text>{t("ChooseAChild")}</Text>
      </HeaderContent>}

      {children && <HeaderContent search right>{children}</HeaderContent>}

      <HeaderContent right>
        <Div worldClose>
          {props?.handleCloseClick ? <CloseIcon onClick={() => props?.handleCloseClick()}>X</CloseIcon> : ""}
        </Div>
      </HeaderContent>

    </HeaderLayout>
  )
}

export function StationHeader(props) {

  const { childcode, back, searchChildData, childName } = props;
  const { setAlert } = useAlert();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  // const { setBackButtonClicked } = useAlert();
  const { persistItemsReducer } = useSelector((state) => state);
  const { loginReducer } = useSelector((state) => state);
  const { sponsorshipsDataReducer } = useSelector((state) => state);
  const { worldReducer } = useSelector((state) => state);
  const [displayGive, setdisplayGive] = useState(false);
  const [showNoSponsorshipMessage, setShowNoSponsorshipMessage] = useState(false)
  const [childSearchModalVisibility, setChildSearchModalVisibility] = useState(false);
  const [clickedButton, setButtonName] = useState("");
  const [selectedChildData, setSelectedChildData] = useState();
  const params = useParams();

  useEffect(() => {
    setSelectedChildData(sponsorshipsDataReducer?.getSponsorshipsData?.activeSponsorships?.filter((item) => { return item?.childCode == decrypt(params?.childcode) })[0]);
  }, [childcode]);
  const [isWriteALetter, setIsWriteALetter] = useState(localStorage.getItem("isWriteALetter") === "true");
  useEffect(() => {
  const handleStorageChange = () => {
  const value = localStorage.getItem("isWriteALetter") === "true";
  setIsWriteALetter(value);
  };
  window.addEventListener("storage", handleStorageChange);
  return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const ifSponsoredChildAvailable = (worldReducer?.childList?.length > 0) && (worldReducer?.childList?.some(child => !!child.childCode));

  const onBackHandler = () => {
    if (window.location.pathname.includes("/connect")) {
      // setBackButtonClicked();
       localStorage.setItem("isWriteALetter", "false");
       window.dispatchEvent(new Event("storage")); // Notify ConnectStories
       return;
    }
    else if (back === "-1") {
      navigate(-1)
    }
    else {
      navigate(`/communityhomeview/${childcode}`)
    }
    gaEvent("BackBtn", persistItemsReducer);
  }
  const handleGAMap = () => {
    gaEvent("MapBtn", persistItemsReducer)
  }
  const handleGAHome = () => {
    gaEvent("HomeBtn", persistItemsReducer)
  }
  const handleGAEventConnect = () => {
    gaEvent("ConnectBtn", persistItemsReducer)
  }
  const handleGAEventStories = () => {
    gaEvent("Stories", persistItemsReducer)
  }
  const handleGAEventGetHelp = () => {
    gaEvent("GetHelpBtn", persistItemsReducer)
  }

  useEffect(() => {
    if (Utilites.GetSOBasedConfiguration(
      loginReducer?.getSOConfiguration,
      "Gift",
      "SendAGift",
    ) || (Utilites.GetSOBasedConfiguration(
      loginReducer?.getSOConfiguration,
      "Gift",
      "SendAGift",
    ) && Utilites.GetSOBasedConfiguration(
      loginReducer?.getSOConfiguration,
      "Gift",
      "Donate",
    ))) { setdisplayGive(true) }
  }, [loginReducer?.getSOConfiguration,]);

  useEffect(() => {
    if (showNoSponsorshipMessage) {
      const IsChildAvaialble = worldReducer?.childList?.some((e) => e?.isSponsor == false);
      if (!IsChildAvaialble) {
        setAlert(t("NoSponsorshipsFound"), t("NoSponsorshipDescription"),
          t("NoSponsorshipDescription2", { AccountDetails: t("AccountDetails"), FindNewChild: t("FindNewChild") }),
          [t("AccountDetails"), t("FindNewChild")],
          "error", false, false, false)
      }
    }
  }, [worldReducer, showNoSponsorshipMessage]);

  const handleMapClick = () => {
    navigate("/home");
  }

  const handleHomeClick = () => {
    if (!ifSponsoredChildAvailable) {
      setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
      return;
    }
    if (window.location.pathname.includes("/pastSponsoredChild")) {
      if (worldReducer?.childList?.length == 0) {
        navigate("/myaccount")
      } else if (worldReducer?.childList?.length > 0) {
        navigate(`/communityhomeview/${encrypt(worldReducer?.childList[0]?.childCode)}`)
      }
    } else {
      navigate(`/communityhomeview/${props?.childcode}`)
    }
  }

  const handleConnectClick = () => {
    if (!ifSponsoredChildAvailable) {
      setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
      return;
    }
    if (window.location.pathname.includes("/pastSponsoredChild")) {
      setChildSearchModalVisibility(true)
      setButtonName("connect");
    } else {
      props.handleConnectClick("connect");
    }
  }

  const handleGiveClick = () => {
    if (!ifSponsoredChildAvailable) {
      setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
      return;
    }
    if (window.location.pathname.includes("/pastSponsoredChild")) {
      setChildSearchModalVisibility(true)
      setButtonName("give")
    } else {
      props.handleGiftClick("give");
    }
  }

  const handleFeedClick = () => {
    if (!ifSponsoredChildAvailable) {
      setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
      return;
    }
    navigate("/newsandstories", {
      state: {
        childcode: props?.childcode,
        childName: selectedChildData?.childFirstName || childName
      }
    }); handleGAEventStories();
  };

  const handleHeaderLogo = () => {
    const isConnectPage = location?.pathname?.includes("/connect");
    if (isConnectPage && isWriteALetter) return false;
    if (location?.pathname?.includes("communityhomeview")
      || location?.pathname?.includes("sendAGift")
      || location?.pathname?.includes("newsandstories")
      || location?.pathname?.includes("getHelp")
      || location?.pathname?.includes("myaccount")
      || location?.pathname?.includes("sponsorships")
      || location?.pathname?.includes("security")
      || location?.pathname?.includes("notification")
      || location?.pathname?.includes("donations")
      || location?.pathname?.includes("connect")
      || location?.pathname?.includes("pastSponsoredChild")) {
      return true;
    } else if (location?.pathname?.includes("community/childprofile")
      || location?.pathname?.includes("community/childcommunity")
      || location?.pathname?.includes("community/station")) {
      return false;
    } else {
      return false;
    }
  }

  return (
    <StationModalHeader ref={element => {
      if (element) element.style.setProperty("display", "flex", "important");
    }}>
      {handleHeaderLogo() ?
        <Div communityheaderLogo>
          <Logo communityheader soCode={persistItemsReducer?.selectedSOData?.soCode} selectedChild={props?.selectedChild} handleHomeClick={handleHomeClick} />
        </Div>
        :
        <BackButton onClick={onBackHandler}>
          <span> {t("DT_WVM_CFIG_HEAD_00004_Back")}</span>
        </BackButton>
      }
      {props?.totalSponsoredChild > 0 && isMobile(1199) &&
        <AutoCompleteWrapper station>
          <AutoCompleteSearch suggestions={searchChildData} searchBy="name" display="displayValue" selectedChild={decrypt(props?.childcode)} />
        </AutoCompleteWrapper>
      }

      {persistItemsReducer?.isLoggedIn ? <Div givemenu>
        {props?.totalSponsoredChild > 0 && !isMobile(1199) &&
          <AutoCompleteWrapper station>
            <AutoCompleteSearch suggestions={searchChildData} searchBy="name" display="displayValue" selectedChild={decrypt(props?.childcode)} />
          </AutoCompleteWrapper>
        }

        <MapIconHeader station onClick={() => { handleMapClick(); handleGAMap() }}>
          <ConnectText isMap={true}>{t("MapView")}</ConnectText>
        </MapIconHeader>
        {childcode && <HomeIconHeader station onClick={() => { handleHomeClick(); handleGAHome() }}>
          <ConnectText>{t("Home")}</ConnectText>
        </HomeIconHeader>}
        {!(props?.navigateFrom == "home") &&
          props?.handleConnectClick && <ConnectIconHeader station onClick={(e) => { e.preventDefault(); handleConnectClick(); handleGAEventConnect() }}>
            <ConnectText>{t("Connect")}</ConnectText>
          </ConnectIconHeader>
        }
        {!(props?.navigateFrom == "home") && displayGive &&
          <GiveIcon station selectedChild={childcode} onClick={() => { handleGiveClick() }} suggestions={searchChildData} navigateFrom="community" />
        }
        {(!(props?.navigateFrom == "home")) &&
          <NewsfeedIconHeader station page="childstation" onClick={handleFeedClick}>
            <ConnectText>{t("Newsfeed")}</ConnectText>
          </NewsfeedIconHeader>
        }
        {
          (!(props?.navigateFrom == "home")) &&
          <HelpIconHeader station onClick={() => { navigate("/getHelp", { state: { childcode: props?.childcode } }); handleGAEventGetHelp() }}>
            <ConnectText>{t("GetHelp")}</ConnectText>
          </HelpIconHeader>
        }
        <MenuIcon header station selectedChild={props?.childcode} navigateFrom={props?.navigateFrom} />
      </Div> : null}

      <ChildSearchView
        isVisible={childSearchModalVisibility}
        setVisibility={() => setChildSearchModalVisibility(false)}
        childGroupList={worldReducer?.childList}
        clickedButton={clickedButton}
        searchData={worldReducer?.childList}
      />

    </StationModalHeader>
  )
}